import React, { useState } from 'react';
import CancelTwoToneIcon from '@mui/icons-material/CancelTwoTone';
import { IconButton } from '@mui/material';
import { usePlacesWidget } from 'react-google-autocomplete';

const Address = ({ data, index, error, setAddress, selectedAddress, setSelectedAddress, addressId }) => {

    // console.log("data Address", data)

    // Callback function when a place is selected from the autocomplete
    const { ref } = usePlacesWidget({
        apiKey: process.env.REACT_APP_GOOGLE_MAP_API_KEY,
        onPlaceSelected: (place) => {
            // console.log('place', place);
            if (place) {
                setSelectedAddress(prevAddress => {
                    const updatedAddress = [...prevAddress];
                    updatedAddress[index] = {
                        ...updatedAddress[index],
                        address: place?.formatted_address,
                        latitude: place?.geometry?.location?.lat(),
                        longitude: place?.geometry?.location?.lng(),
                    };
                    return updatedAddress;
                });
            }
        },
        options: {
            types: ['geocode', 'establishment'],
            // componentRestrictions: { country: 'in' },
        },
    });

    // Function to remove an address from the list
    const removeHandler = (id) => {
        setSelectedAddress(prevSelectedAddress => prevSelectedAddress.filter(item => item.id !== id));
        // setAddress(prevAddress => prevAddress.filter(item => item.id !== id));
    };


    return (
        <div className='add_user_form_field'>
            <input
                ref={ref}
                type="text"
                name="address"
                placeholder="Select location"
                // className='form-control mb-3'
                className={`form-control mt-3 ${!data.address && error.address && "is-invalid"}`}
                defaultValue={data?.address} // Use value instead of defaultValue for controlled input
            // onChange={(e) => setAddressValue(e.target.value)} // Update addressValue state
            />
            <span className="invalid-feedback">{error.address}</span>

            {index > 0 &&
                <div className="">
                    <IconButton className='remove_user_icon' onClick={() => removeHandler(data?.id)}>
                        <CancelTwoToneIcon sx={{ color: "#0489DE", fontSize: 28 }} />
                    </IconButton>
                </div>}
        </div>
    );
};

export default Address;
